import Repository from "./Repository";

const ADD_ENTRY = "add";
const DELETE_ENTRY = "delete";
const UPDATE_ENTRY = "update";
const GET_ENTRY = "get";
const GET_ONE_ENTRY = "getSingle"
const DELETE_ALL_ENTRY = "deleteAll"

export default {
  getAllCollections(){ 
    return Repository.get(transformRoute(GET_ENTRY));
  },
  getOneCollection(payload){ 
    return Repository.post(transformRoute(GET_ONE_ENTRY), payload);
  },
  addOneCollection(payload) {
    return Repository.post(transformRoute(ADD_ENTRY), payload);
  },
  editOneCollection(payload) {
    return Repository.post(transformRoute(UPDATE_ENTRY), payload);
  },
  deleteOneCollection(payload) {
    return Repository.post(transformRoute(DELETE_ENTRY), payload);
  }, 
  deleteAll() {
    return Repository.post(transformRoute(DELETE_ALL_ENTRY));
  }

};

const transformRoute = route => {
  return `/cart/${route}`;
};
